import { SET_FINANCIAL_LIENS, UPDATE_FINANCIAL_LIENS, FINANCIAL_LIEN_FAILED } from '../../types';

const initialState = { FinancialLiensData: [] };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_FINANCIAL_LIENS:
            return {
                ...state,
                FinancialLiensData: [...payload]
            };
        case UPDATE_FINANCIAL_LIENS:
            return {
                ...state,
                FinancialLiensData: [...payload]
            };
        case FINANCIAL_LIEN_FAILED:
            return {
                ...state,
                FinancialLiensData: []
            };
        default:
            return state;
    }
}